<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="acknow"></a></div>
<h4 class="fronthead">A<span class="sc">CKNOWLEDGEMENTS</span></h4>
<p class="center"><img alt="" src="html/docimages/image1.jpg" width="100%"/></p>
<p class="textbreak">I would like to thank my husband Dave for his love and constant support.</p>
<p class="textbreak">Also my precious children and grandchildren.</p>
<p class="textbreak">My beloved mother, Jeannie. Always with me.</p>
<p class="textbreak">Shirley, Dave and family for believing in me.</p>
<p class="textbreak">My dear friends Maimie, Sonja, Mona, Alison, Kay, Donald, Malcolm, Harry and the Writers Group.</p>
<p class="textbreak">Maurice Fleming and John Beaton, who set the word in motion.</p>
<p class="textbreak">Tom, Catherine and Seán.</p>
<p class="textbreak">And to those too numerous to mention—thank you all, from my heart.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_acknow.vue?35ebc2c5